import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex'
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    }
}));

export default function EmptyLayout({ children, ...otherProps }) {
    
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <main className={classes.content}>
                {children}
            </main>
        </div>
    );
}
